module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_nordland_pos.8181276f.pdf";